import { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Modal,
  message,
  Table,
  Input,
  Spin,
  Switch,
  Popconfirm,
  Segmented,
} from "antd";
import {
  ApiOutlined,
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import MqttComponentForm from "./iotGateWayComponentForm";
import {
  connectMqtt,
  deleteMqtt,
  disConnectMqtt,
  fetchMqtt,
  postMqtt,
  putMqtt,
  subscribeMqtt,
  unSubscribeMqtt,
} from "../Service/iotGateWayService";

let searchTimeout = null;

const IotGateWayComponent = () => {
  const [mqtts, setMqtts] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isGatewayModalOpen, setIsGatewayModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("descend");
  const [activeTab, setActiveTab] = useState("Connection status");

  const fetchData = async (
    pageNum = page,
    pageSize = size,
    searchText = search,
    field = sortField,
    order = sortOrder
  ) => {
    setLoading(true);
    try {
      const res = await fetchMqtt({
        page: pageNum - 1,
        size: pageSize,
        search: searchText || "",
        sort: field,
        desc: order === "descend",
      });

      setMqtts(res.data.content || []);
      setTotal(res.data.totalElements || 0);
      setPage(pageNum);
      setSize(pageSize);
      setSortField(field);
      setSortOrder(order);
    } catch (err) {
      message.error("Network error while fetching IoT Gateways");
    } finally {
      setLoading(false);
    }
  };
  // const connectMqttCall = async () => {
  //   try {
  //     setLoading(true);
  //     await connectMqtt(editData?.uuid);
  //     message.success("Connected successfully");
  //     fetchData(1, size, search);
  //     setEditData(null);
  //     setIsGatewayModalOpen(false);
  //   } catch (error) {
  //     message.error(error?.response?.data || "Failed to connect");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const disConnectMqttCall = async () => {
  //   try {
  //     setLoading(true);
  //     await disConnectMqtt(editData?.uuid);
  //     message.success("Disconnected successfully");
  //     fetchData(1, size, search);
  //     setEditData(null);
  //     setIsGatewayModalOpen(false);
  //   } catch (error) {
  //     message.error(error?.response?.data || "Failed to disconnect");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const subscribeMqttCall = async () => {
  //   try {
  //     setLoading(true);
  //     await subscribeMqtt(editData?.uuid);
  //     message.success("Subscribed successfully");
  //     fetchData(1, size, search);
  //     setEditData(null);
  //     setIsGatewayModalOpen(false);
  //   } catch (error) {
  //     message.error(error?.response?.data || "Failed to subscribe");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const unSubscribeMqttCall = async () => {
  //   try {
  //     setLoading(true);
  //     await unSubscribeMqtt(editData?.uuid);
  //     message.success("Unsubscribed successfully");
  //     fetchData(1, size, search);
  //     setEditData(null);
  //     setIsGatewayModalOpen(false);
  //   } catch (error) {
  //     message.error(error?.response?.data || "Failed to unsubscribe");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleMqttAction = async ({ apiFn, successMsg, errorMsg }) => {
    if (!editData?.uuid) return;

    try {
      setLoading(true);
      await apiFn(editData.uuid);

      message.success(successMsg);
      fetchData(1, size, search);

      setEditData(null);
      setIsGatewayModalOpen(false);
    } catch (error) {
      message.error(error?.response?.data || errorMsg);
    } finally {
      setLoading(false);
    }
  };
  const connectMqttCall = () =>
    handleMqttAction({
      apiFn: connectMqtt,
      successMsg: "Connected successfully",
      errorMsg: "Failed to connect",
    });

  const disConnectMqttCall = () =>
    handleMqttAction({
      apiFn: disConnectMqtt,
      successMsg: "Disconnected successfully",
      errorMsg: "Failed to disconnect",
    });

  const subscribeMqttCall = (resumeAssets) =>
    handleMqttAction({
      apiFn: (uuid) => subscribeMqtt(uuid, resumeAssets),
      successMsg: resumeAssets
        ? "Subscribed and assets resumed successfully"
        : "Subscribed successfully",
      errorMsg: "Failed to subscribe",
    });

  const unSubscribeMqttCall = () =>
    handleMqttAction({
      apiFn: unSubscribeMqtt,
      successMsg: "Unsubscribed successfully",
      errorMsg: "Failed to unsubscribe",
    });

  const saveData = async (data) => {
    setLoading(true);
    const {
      createdBy,
      createdDate,
      id,
      uuid,
      lastModifiedBy,
      lastModifiedDate,
      ...payload
    } = data;
    try {
      if (editData) {
        await putMqtt(payload, editData.uuid);
      } else {
        await postMqtt(payload);
      }
      messageApi.success(
        `IoT Gateway ${editData ? "updated" : "added"} successfully`
      );
      handleCancel();
      fetchData(1, size, search);
    } catch (err) {
      messageApi.error("Error while saving IoT Gateway");
    } finally {
      setLoading(false);
    }
  };

  const deleteData = async (uuid) => {
    try {
      await deleteMqtt(uuid);
      messageApi.success("IoT Gateway deleted successfully");
      fetchData(1, size, search);
    } catch (err) {
      messageApi.error("Error while deleting IoT Gateway");
    }
  };

  const handleCancel = () => {
    fetchData(1, size, search);
    setIsModalOpen(false);
    setEditData(null);
  };
  const handleConnectionModalCancel = () => {
    fetchData(1, size, search);
    setIsGatewayModalOpen(false);
    setEditData(null);
  };

  useEffect(() => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      fetchData(1, size, search);
    }, 500);

    return () => clearTimeout(searchTimeout);
  }, [search]);

  useEffect(() => {
    fetchData();
  }, []);
  const columns = [
    {
      title: "Broker Name",
      dataIndex: "brokerName",
      key: "brokerName",
      sorter: true,
      sortOrder: sortField === "brokerName" ? sortOrder : null,
    },
    {
      title: "Broker URL",
      dataIndex: "brokerUrl",
      key: "brokerUrl",
      sorter: true,
      sortOrder: sortField === "brokerUrl" ? sortOrder : null,
    },
    {
      title: "Server Port",
      dataIndex: "serverPort",
      key: "serverPort",
    },
    {
      title: "Client ID",
      dataIndex: "clientId",
      key: "clientId",
      sorter: true,
      sortOrder: sortField === "clientId" ? sortOrder : null,
    },
    {
      title: "Subscription Topic",
      dataIndex: "subTopicName",
      key: "subTopicName",
      sorter: true,
      sortOrder: sortField === "subTopicName" ? sortOrder : null,
    },
    {
      title: "Publish Topic",
      dataIndex: "pubTopicName",
      key: "pubTopicName",
      sorter: true,
      sortOrder: sortField === "pubTopicName" ? sortOrder : null,
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (val) => (
    //     <Switch
    //       checked={val}
    //       disabled
    //       checkedChildren="Active"
    //       unCheckedChildren="In-active"
    //     />
    //   ),
    // },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <>
          <ApiOutlined
            style={{ marginRight: 12, cursor: "pointer" }}
            onClick={() => {
              setIsGatewayModalOpen(true);
              setEditData(record);
            }}
          />
          <EditOutlined
            style={{
              marginRight: 12,
              cursor:
                record.connectionStatus || record.subscriptionStatus
                  ? "not-allowed"
                  : "pointer",
              color:
                record.connectionStatus || record.subscriptionStatus
                  ? "#bfbfbf"
                  : undefined,
            }}
            onClick={() => {
              if (record.connectionStatus || record.subscriptionStatus) return;

              setEditData(record);
              setIsModalOpen(true);
            }}
          />

          {record.connectionStatus || record.subscriptionStatus ? (
            <DeleteOutlined
              style={{
                marginRight: 12,
                cursor: "not-allowed",
                color: "#bfbfbf",
              }}
            />
          ) : (
            <Popconfirm
              title="Delete Gateway?"
              description="Are you sure you want to delete this gateway?"
              onConfirm={() => deleteData(record.uuid)}
              okText="Yes"
              cancelText="No"
              placement="topRight"
            >
              <DeleteOutlined
                style={{
                  marginRight: 12,
                  cursor: "pointer",
                }}
              />
            </Popconfirm>
          )}
        </>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ width: "100%" }}>
        {contextHolder}
        <Flex
          justify="space-between"
          align="center"
          style={{ marginBottom: 16 }}
        >
          <div style={{ fontSize: "1rem", fontWeight: 700 }}>IOT Gateway</div>
          <Flex gap={8}>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Button onClick={() => setIsModalOpen(true)} type="primary">
              Add
            </Button>
          </Flex>
        </Flex>

        <Table
          rowKey="id"
          columns={columns}
          dataSource={mqtts}
          bordered
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: size,
            total,
            showSizeChanger: true,
          }}
          onChange={(pagination, filters, sorter) => {
            const field = sorter.field || sortField;
            const order = sorter.order || sortOrder;

            fetchData(
              pagination.current,
              pagination.pageSize,
              search,
              field,
              order
            );
          }}
        />

        <Modal
          title={`${editData ? "Edit" : "Add"} Gateway Details`}
          centered
          open={isModalOpen}
          footer={false}
          onCancel={handleCancel}
        >
          <MqttComponentForm editData={editData} saveData={saveData} />
        </Modal>
        <Modal
          title="Gateway Connection"
          open={isGatewayModalOpen}
          footer={false}
          onCancel={handleConnectionModalCancel}
        >
          <Spin spinning={loading}>
            <Segmented
              options={["Connection status", "Subscription status"]}
              block
              value={activeTab}
              onChange={setActiveTab}
              style={{ marginBottom: 16 }}
            />
            {activeTab === "Connection status" && (
              <>
                <img
                  alt="connection status"
                  src={`${process.env.PUBLIC_URL}/images/${
                    editData?.connectionStatus ? "connected" : "disconnected"
                  }.jpg`}
                  style={{ width: "100%", marginBottom: 12 }}
                />

                <Button
                  type="primary"
                  block
                  disabled={editData?.connectionStatus}
                  onClick={connectMqttCall} // ✅ FIXED
                  style={{ marginBottom: 8 }}
                >
                  Connect
                </Button>

                <Button
                  danger
                  block
                  disabled={
                    !editData?.connectionStatus || editData?.subscriptionStatus
                  }
                  onClick={disConnectMqttCall}
                >
                  Disconnect
                </Button>
              </>
            )}

            {/* SUBSCRIPTION STATUS */}
            {activeTab === "Subscription status" && (
              <>
                <img
                  alt="subscription status"
                  src={`${process.env.PUBLIC_URL}/images/${
                    editData?.subscriptionStatus ? "connected" : "disconnected"
                  }.jpg`}
                  style={{ width: "100%", marginBottom: 12 }}
                />

                <Popconfirm
                  title="Resume Asset Data?"
                  description="Do you want to resume saving data for all associated machines?"
                  onConfirm={() => subscribeMqttCall(true)} // YES
                  onCancel={() => subscribeMqttCall(false)} // NO
                  okText="Yes, Resume"
                  cancelText="No, Subscribe Only"
                  placement="topRight"
                  disabled={
                    !editData?.connectionStatus || editData?.subscriptionStatus
                  }
                >
                  <Button
                    type="primary"
                    block
                    disabled={
                      !editData?.connectionStatus ||
                      editData?.subscriptionStatus
                    }
                    style={{ marginBottom: 8 }}
                  >
                    Subscribe
                  </Button>
                </Popconfirm>

                <Popconfirm
                  title="Unsubscribe Gateway?"
                  description="Do you want to stop saving data for all associated machines?"
                  onConfirm={unSubscribeMqttCall}
                  okText="Yes, Unsubscribe"
                  cancelText="Cancel"
                  placement="topRight"
                  disabled={
                    !editData?.connectionStatus || !editData?.subscriptionStatus
                  }
                >
                  <Button
                    danger
                    block
                    disabled={
                      !editData?.connectionStatus ||
                      !editData?.subscriptionStatus
                    }
                  >
                    Unsubscribe
                  </Button>
                </Popconfirm>
              </>
            )}
          </Spin>
        </Modal>
      </div>
    </Spin>
  );
};

export default IotGateWayComponent;
